export const uniqSizeLabel = ['1SIZE', 'UNIQ', 'UNIQ.', 'UNIQUE', 'TU'];
